import { SVGProps } from 'react';
const SvgParagraph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 5v14m4-14v14M17 5h-6a4 4 0 1 0 0 8h1"
    />
  </svg>
);
export default SvgParagraph;
